export const emptyContentStyle = {
	wrapper: {
		position: 'relative',
		top: '192px',
		display: 'flex',
		alignItems: 'center',
		flexDirection: 'column',
	} as any,

	icon: {
		marginBottom: '22px',

		svg: {
			width: '60px',
			height: '60px',

			path: {
				fill: 'var(--neutral-200)',
			},
		},
	},

	button: {
		marginTop: '46px',
		maxWidth: '228px',
		width: '100%',

		svg: {
			height: '24px',
			width: '24px',

			path: {
				fill: 'var(--primary-500)',
			},
		},
	},

	title: {
		color: '#C3C7D4',
		textAlign: 'center',
	},
};
